<template>
	<loading-indicator v-if="loading" class="my-5" />
	<validation-observer v-else v-bind="$attrs" ref="observer" v-slot="{ invalid }">
		<b-form @submit.prevent="save" >
			<b-card no-body>
				<slot name="header"></slot>

				<b-card-body>

					<b-row>
						<b-col cols="12" lg="4">
						<validation-provider
							vid="first_name"
							name="First Name"
							:rules="{ required: true, min: 3, max: 50 }"
							v-slot="validationContext"
						>
							<b-form-group label="First Name" label-for="first_name">
							<b-form-input
								id="first_name"
								v-model="entity.first_name"
								:state="getValidationState(validationContext)"
								:disabled="saving"
							/>
							<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
							</b-form-group>
						</validation-provider>
						</b-col>

						<b-col cols="12" lg="4">
						<validation-provider
							vid="middle_name"
							name="Middle Name"
							:rules="{ required: false, max: 50 }"
							v-slot="validationContext"
						>
							<b-form-group label="Middle Name" label-for="middle_name">
							<b-form-input
								id="middle_name"
								v-model="entity.middle_name"
								:state="getValidationState(validationContext)"
								:disabled="saving"
							/>
							<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
							</b-form-group>
						</validation-provider>
						</b-col>

						<b-col cols="12" lg="4">
						<validation-provider
							vid="last_name"
							name="Last Name"
							:rules="{ required: true, min: 3, max: 50 }"
							v-slot="validationContext"
						>
							<b-form-group label="Last Name" label-for="last_name">
							<b-form-input
								id="last_name"
								v-model="entity.last_name"
								:state="getValidationState(validationContext)"
								:disabled="saving"
							/>
							<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
							</b-form-group>
						</validation-provider>
						</b-col>
					</b-row>

					
					<b-row>
						<b-col cols="12" lg="4">
						<validation-provider
							vid="email"
							name="Email"
							:rules="{ required: true, email: true, max: 50 }"
							v-slot="validationContext"
						>
							<b-form-group label="Email" label-for="email">
							<b-form-input
								id="email"
								type="email"
								v-model="entity.email"
								:state="getValidationState(validationContext)"
								:disabled="saving"
								:readonly="isCurrentUser"
							/>
							<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
							</b-form-group>
						</validation-provider>
						</b-col>

						<b-col cols="12" lg="4">
						<validation-provider
							vid="phone"
							name="Phone"
							:rules="{ required: true, regex: /^[0-9]{10}$/ }"
							v-slot="validationContext"
						>
							<b-form-group label="Phone" label-for="phone">
							<b-form-input
								id="phone"
								type="text"
								v-model="entity.phone"
								:state="getValidationState(validationContext)"
								:disabled="saving"
							/>
							<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
							</b-form-group>
						</validation-provider>
						</b-col>

						<b-col cols="12" lg="4">
						<validation-provider
									vid="birthday"
									name="Birthday"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Birthday" label-for="birthday">
										<b-form-input
											name="birthday"
											type="date"
											:max="today"
											v-model="entity.date_of_birth"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>
                            </b-col>
                         </b-row>
                    </b-card-body>
                    <b-card-body>
							<!-- <b-form-group
									label="Active"
									label-for="active"
									label-cols-lg="4"
									description="Allows user to log in to the application."
							>
							<b-form-checkbox name="active" v-model="entity.active" :disabled="saving">
										Active
									</b-form-checkbox>
							</b-form-group> -->
                            
							<div>
								<div class="d-flex align-items-center ">
									<label for="active" class="mr-2 mb-0">Active</label>
									<b-form-checkbox
									id="active"
									name="active"
									v-model="entity.active"
									:disabled="saving"
									class="mb-0" 
									/>
								</div>
								<p class="mb-2 text-muted">Allows user to log in to the application.</p>
							</div>
                            <b-form-group label="Roles" label-for="role_ids" label-cols-lg="4">
								<b-form-checkbox-group
									v-if="roles && roles.length > 0"
									stacked
									name="role_ids"
									v-model="entity.roles._ids"
									:options="roles"
									:disabled="saving || loadingRoles"
									value-field="id"
									text-field="name"
								/>
								<empty-result v-else>
									No roles created
									<template #content>
										Roles can be created to grant users permissions to features.
									</template>
								</empty-result>
							</b-form-group>
								
								
							</b-card-body>
				


				<!-- <b-card-body>
					<h6 class="text-muted">Optional</h6>
					<b-card no-body class="mb-0">
						<b-card-header header-tag="header" role="tab" class="p-0">
							<b-button
								block
								v-b-toggle.collapseAdditional
								variant="light"
								role="tab"
								class="text-left px-4 py-3 m-0"
							>
								Additional Details
							</b-button>
						</b-card-header>
						<b-collapse id="collapseAdditional" role="tabpanel">
							<b-card-body>
								<validation-provider
									vid="birthday"
									name="Birthday"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Birthday" label-for="birthday" label-cols-lg="4">
										<b-form-input
											name="birthday"
											type="date"
											:max="today"
											v-model="entity.date_of_birth"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>

								<validation-provider
									vid="phone"
									name="Phone"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Phone" label-for="phone" label-cols-lg="4">
										<b-form-input
											name="phone"
											type="tel"
											v-model="entity.phone"
											v-mask="`(###) ###-####`"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
									</b-form-group>
									<b-form-invalid-feedback
										v-for="error in validationContext.errors"
										:key="error"
										v-text="error"
									/>
								</validation-provider>
							</b-card-body>
						</b-collapse>
					</b-card>
				</b-card-body> -->

				<b-card-footer>
					<b-row>
						<b-col cols="12" md="6" xl="4" class="mb-4 mb-md-0">
							<b-button block variant="light" type="button" @click.stop="cancel" class="btn btn-outline-danger"> Cancel </b-button>
						</b-col>
						<b-col cols="12" md="6" offset-xl="4" xl="4" class="mb-2 mb-md-0">
							<b-button block variant="light" type="submit" :disabled="saving || invalid" class="btn btn-outline-primary">
								<font-awesome-icon icon="circle-notch" v-if="saving" spin fixed-width />
								<span>Save</span>
							</b-button>
						</b-col>
					</b-row>
				</b-card-footer>
			</b-card>
		</b-form>
	</validation-observer>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import { formatErrors, getValidationState } from "@/validation";
import axios from "axios";

export default {
	name: "UserEditForm",
	props: {
		id: {
			default: null,
		},
	},
	data() {
		return {
			loading: true,
			saving: false,
			entity: {
				id: this.id,
				first_name: null,
				middle_name: null,
				last_name: null,
				email: null,
				active: true,
				roles: {
					_ids: [],
				},
			},
			today: new Date().toISOString().split('T')[0],
			countData:{
				appeal:0,
				case:0,
				case_request:0
			},
		};
	},
	computed: {
		isCurrentUser() {
			return this.id == this.userId;
		},
		...mapGetters({
			userId: "userId",
			roles: "roles/all",
			loadingRoles: "roles/loadingAll",
		}),
	},
	mounted() {
		if (this.id) {
			this.refresh();
		} else {
			this.loading = false;
		}
	},
	methods: {
		getValidationState,
		cancel() {
			this.$emit("cancel");
		},
		async refresh() {
			try {
				this.loading = true;

				const response = await this.$store.dispatch("users/get", {
					id: this.id,
				});

				this.entity = response;
				if (response.roles) {
					this.entity.roles = {
						_ids: response.roles.map((item) => item.id),
					};
				}

				this.$emit("loaded", response);
				this.fetch_Case_Appeal_Request_Count_Assignedto_User();
			} catch (e) {
				this.$store.dispatch("apiError", {
					error: e,
					message: "Error getting user details",
				});
			} finally {
				this.loading = false;
			}
		},
		async save(e) {
			if(!this.entity.active){
				let message = "";
				if(this.countData.case>0 || this.countData.appeal>0 || this.countData.case_request>0){
					message = "This user has: ";
					if (this.countData.case > 0) {
					message += `total no. assigned of Cases: ${this.countData.case}.`;
					}

					if (this.countData.appeal > 0) {
					message += `total no. assigned of Appeals: ${this.countData.appeal}.`;
					}

					if (this.countData.case_request > 0) {
					message += `total no. assigned of Case Requests: ${this.countData.case_request}.`;
					}

					// this.$store.dispatch("notify", {
					// 	variant: "warning", // Alert type set to warning
					// 	title: "Warning",
					// 	message: message, // Dynamic message with counts
					// 	actions: [
					// 		{
					// 		label: "Cancel",
					// 		handler: () => {
					// 			// Handle the cancel action here
					// 			console.log("User clicked Cancel");
					// 		},
					// 		},
					// 		{
					// 		label: "OK",
					// 		handler: () => {
					// 			// Handle the OK action here
					// 			console.log("User clicked OK");
					// 		},
					// 		},
					// 	],
					// });
				}
				else{
					message = "⚠️ Are you sure you want to make this User Inactive?";
				}
				if (!confirm(message)) {
					return false;
				}
			}
			try {
				this.saving = true;
				const response = await this.$store.dispatch("users/update", this.entity);
				this.$emit("saved", response);
			} catch (e) {
				if (e.response.data.errors) {
					this.$refs.observer.setErrors(formatErrors(e.response.data.errors));
				}

				this.$store.dispatch("apiError", {
					error: e,
					title: "Save Failed",
					message: "Error updating user details. Please check for errors.",
					variant: "warning",
				});
			} finally {
				this.saving = false;
			}
		},
		async fetch_Case_Appeal_Request_Count_Assignedto_User(){
			try {
				
				let data = {id : this.id};
				const response = await axios.post('/client/api/fetchAssignedtoUserData', data);

				this.countData = response.data;
			} 
			catch (error) {
				console.error('An error occurred:', error);
			}
		},
	},
};
</script>